module.exports = __webpack_public_path__ + "static/media/mda_logo.574c33fa.png";